<template>
  <div>
    <slot name="headline" v-if="assignments.length"></slot>
    <ul :class="['assignment-items', { 'is-odd': ((assignments.length+1) % 2 === 0) }]" v-if="assignments.length">
      <assignment-item :blast="blast" v-for="blast in assignments" :key="blast.id" />
    </ul>
    <div v-else>
      <slot name="empty"></slot>
    </div>
  </div>
</template>

<script>
  import AssignmentItem from "./item"
  export default {
    name: 'assignmentList',
    components: { AssignmentItem },
    props: {
      assignments: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~globals";

  .assignment-items {
    @include list-style-reset;
    display:flex; flex-wrap:wrap; justify-content:space-between;
  }

</style>



// WEBPACK FOOTER //
// src/components/AssignmentList/index.vue